import cn from "classnames";
import { Loader } from "../../../loader";
import { A11yRoot } from "../../../a11y";
import { useOptionsA11y } from "./hooks";
import { NotFoundLabel } from "./not-found-label";
import { Option } from "./option";
import { OptionsProps } from "./types";
import styles from "./styles.module.scss";

export const Options = ({
  id,
  options,
  dataTestId,
  searchValue,
  notFoundLabel,
  isLoading,
  onClick,
}: OptionsProps) => {
  const hasNotSearchResult =
    isLoading && Boolean(searchValue.length) && !options.length;

  const {
    optionsRef,
    a11yCurrentChildIndex,
    resetFocus,
    setA11yChildRefs,
    handleArrowUp,
    handleArrowDown,
    handleEnterKeyDown,
  } = useOptionsA11y({ maxIndex: options?.length - 1 });

  return (
    <A11yRoot
      onAfterBlur={resetFocus}
      onArrowUp={handleArrowUp}
      onArrowDown={handleArrowDown}
      onEnter={handleEnterKeyDown}
    >
      <ul
        id={id}
        role="listbox"
        ref={optionsRef}
        data-test-id={dataTestId}
        className={cn(styles.options, {
          [styles["no-padding"]]: hasNotSearchResult && !notFoundLabel,
        })}
      >
        {(isLoading && (
          <div className={styles["loader-box"]}>
            <Loader
              dataTestId={`${dataTestId}-loader`}
              className={styles.loader}
            />
          </div>
        )) ||
          (options?.length &&
            options.map((option, index) => (
              <Option
                key={option.label + index}
                option={option}
                searchValue={searchValue}
                a11yChildRef={setA11yChildRefs(index)}
                hasA11yFocus={a11yCurrentChildIndex === index}
                dataTestId={`${dataTestId}-item`}
                onClick={onClick}
              />
            ))) || (
            <NotFoundLabel text={notFoundLabel} dataTestId={dataTestId} />
          )}
      </ul>
    </A11yRoot>
  );
};
